import { Button } from '@givebutter/primitives/button';
import { show as showIntercomChat } from '@intercom/messenger-js-sdk';
import Content from 'assets/js/components/Content';

const NotFound = () => (
    <Content>
        <div className="flex flex-col items-center justify-center gap-2">
            <h1 className={'text-2xl font-medium'}>Whoops!</h1>
            <p>Looks like this page doesn't exist or you don't have access.</p>
            <p>
                Need help?{' '}
                <Button variant="none" color="primary" onClick={showIntercomChat}>
                    Message us
                </Button>
            </p>
        </div>
    </Content>
);

export default NotFound;
